import React from 'react';
import {
    Grid,
    Paper,
    Table,
    TableBody
} from 'material-ui';
import RevisionsTableHeader from './RevisionsTableHeader';
import RevisionsTableContent from './RevisionsTableContent';
import RevisionDeleteDialog from './RevisionDeleteDialog';
import {BackButton} from '../../../components/buttons/BackButton';

class RevisionsTable extends React.Component {

    render() {
        const {
            classes,
            block,
            blockRevisions,
            approvedRevision,
            handleActive,
            handleSubmit,
            handleClickOpen,
            handleRequestClose,
            open,
        } = this.props;

        return (
            <Grid container>
                <div className="heading">
                    <p className="lead">Revisions for Block <em>"{block.display_name}"</em></p>
                </div>
                <Paper className={classes.rootRevisionsTable}>
                {blockRevisions.length === 0 ?
                    <div className={classes.messageNoEntries}>There are no revisions for this block!</div>
                :
                    <Table className={classes.table}>
                        <RevisionsTableHeader
                            classes={classes}
                        />
                        <TableBody>
                            {blockRevisions.map(revision =>
                                <RevisionsTableContent
                                    key={revision.id}
                                    block={block}
                                    revision={revision}
                                    approvedRevision={approvedRevision}
                                    handleActive={handleActive}
                                    handleClickOpen={handleClickOpen}
                                    classes={classes}
                                />
                            )}
                        </TableBody>
                        <RevisionDeleteDialog
                            open={open}
                            handleSubmit={handleSubmit}
                            handleRequestClose={handleRequestClose}
                        />
                    </Table>
                }
                </Paper>
                <Grid container spacing={0}>
                    <Grid item xs={12} className={classes.buttons}>
                        <BackButton
                            link={"/blocks"}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default RevisionsTable;


// WEBPACK FOOTER //
// ./src/containers/blocks/revisions/RevisionsTable.jsx